var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c("DebugInfo"),
      _vm._v(" "),
      _vm.isHitQBResult
        ? _c("QBResult", {
            attrs: {
              "get-doc-info": _vm.getDocInfo,
              "get-short-video-play-info": _vm.getShortVideoPlayInfo,
            },
            on: { onTagChange: _vm.handleTagChange },
          })
        : _c("H5Result", {
            attrs: {
              "get-doc-info": _vm.getDocInfo,
              "get-short-video-play-info": _vm.getShortVideoPlayInfo,
            },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }